import { CollapsibleSection } from "components/collapsibleSection";
import { IOrderAddonItem, IOrderDetail } from "interfaces";
import { get, isEmpty } from "lodash";
import { AddonProductCard } from "./card";
import { AddonProductTable } from "./table";

export const AddonProductSection = ({
  orderDetailData,
  rate,
}: {
  orderDetailData: IOrderDetail | null;
  rate: number;
}) => {
  const addonProducts = get(orderDetailData, "addons", []) as IOrderAddonItem[];

  return (
    <CollapsibleSection label="Addon product" defaultOpen={true}>
      <div className="px-4 py-4 sm:px-6">
        {isEmpty(addonProducts) ? (
          <div className="text-center">No data</div>
        ) : (
          <>
            <div className="hidden sm:block">
              <AddonProductTable
                data={addonProducts}
                orderCurrency={orderDetailData?.currency ?? ""}
                rate={rate}
              />
            </div>
            <div className="sm:hidden">
              <AddonProductCard
                data={addonProducts}
                orderCurrency={orderDetailData?.currency ?? ""}
                rate={rate}
              />
            </div>
          </>
        )}
      </div>
    </CollapsibleSection>
  );
};
